
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightDeckColourOff as ObiLightDeckColourOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-deck-colour-off.js';
 
 
 

 
 export const ObiLightDeckColourOff = createComponent({
   react: React,
   tagName: 'obi-light-deck-colour-off',
   elementClass: ObiLightDeckColourOffElement,
   events: {
     
   }
  });
 
 